var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"innerItem"},[_c('p',{staticClass:"innerTitle setLabel"},[_vm._v(_vm._s(_vm.locale.setting_site_title))]),_c('SetLanguageValue',{attrs:{"locale":_vm.locale,"langValue":_vm.site.title}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }